module.exports = __webpack_public_path__ + "compatibility-checker/img/logo-vzc.a77e4607.svg";